import React, { useState, useEffect } from 'react';
import {
    Row, Col, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText,
    Button
} from 'reactstrap';
import { saveAccount, getAccount } from '../../API';
import { usStates } from '../../Helper';
import LoadingSVG from '../../icons/Spinner-1s-200px.svg';

function AccountEdit(props) {
    const [account, setAccount] = useState(null);
    const [isLoadingAccount, setIsLoadingAccount] = useState(true);

    useEffect(() => {
        fetchAccount();
    }, []);

    const fetchAccount = async () => {
        setIsLoadingAccount(true);

        const resultAccount = await getAccount(props.match.params.accountId);
        setAccount(resultAccount);

        setIsLoadingAccount(false);
    }

    const updateAccount = e => {
        let value = e.target.value;
        if (e.target.name === 'isActive')
            value = e.target.value === 'true';
        setAccount({
            ...account,
            [e.target.name]: value
        });
    }

    const cancel = () => {
        console.log('Canceling...');
        props.history.goBack();
    };

    const save = async () => {
        //console.log('Saving...');
        //const index = store.accounts.findIndex(o => o.id === account.id);
        //store.accounts[index] = Object.assign(store.accounts[index], account);
        if (await saveAccount(account))
            props.history.goBack();
    };

    let accountJSX = (<div>No Onwer Found...</div>);
    if (isLoadingAccount) {
        accountJSX = (<div className="loading"><img src={LoadingSVG} alt="Loading..." /></div>)
    } else if (account) {
        accountJSX = (
            <div className="item-editables">
                <Row xs={1} md={2} lg={3} xl={4}>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-check-square"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input type="select" name="isActive" value={account.isActive} onChange={updateAccount}>
                                    <option value={true}>Active</option>
                                    <option value={false}>Inactive</option>
                                </Input>
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-city"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input placeholder="Account" name="name" value={account.name} onChange={updateAccount} />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-asterisk"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input placeholder="Account Number" name="accountNumber" value={account.accountNumber} onChange={updateAccount} />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-user"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input placeholder="Salutation" name="salutation" value={account.salutation} onChange={updateAccount} />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-user"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input placeholder="First Name" name="contactFirstName" value={account.contactFirstName} onChange={updateAccount} />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-user"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input placeholder="Last Name" name="contactLastName" value={account.contactLastName} onChange={updateAccount} />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-map-marker-alt"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input placeholder="Address" name="address" value={account.address} onChange={updateAccount} />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-map-marker-alt"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input placeholder="City" name="city" value={account.city} onChange={updateAccount} />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-map-marker-alt"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input type="select" name="state" value={account.state} onChange={updateAccount}>
                                    {usStates.map(s => (<option key={s.abbreviation} value={s.abbreviation}>{s.name}</option>))}
                                </Input>
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-map-marker-alt"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input placeholder="Zip" name="zip" value={account.zip} onChange={updateAccount} />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-envelope"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input placeholder="Email" name="emailAddress" value={account.emailAddress} onChange={updateAccount} />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                </Row>
                <Row xs={1} md={2} lg={3} xl={4}>
                    <Col className="col" md={{ span: 6 }} lg={{ span: 4, offset: 4 }} xl={{ span: 3, offset: 6 }}>
                        <Button className="btn-block btn-icon" color="danr-red" onClick={cancel}><i className="fas fa-ban"></i><span>Cancel</span></Button>
                    </Col>
                    <Col className="col" md={{ span: 6 }} lg={{ span: 4 }} xl={{ span: 3 }}>
                        <Button className="btn-block btn-icon" color="danr-green" onClick={save}><i className="fas fa-save"></i><span>Save</span></Button>
                    </Col>
                </Row>
            </div>
        );
    }

    return (
        <div>
            <Row className="title-row">
                <Col>
                    <h1>{account?.name} Account</h1>
                </Col>
            </Row>
            <Row className="edit-row">
                <Col>
                    {accountJSX}
                </Col>
            </Row>
        </div>
    );
}

export default AccountEdit;